// utils/salesLevelOptions.ts
import { SalesforceSalesLevels } from "../types/salesforce";

export function getSalesLevelOptions(
  salesLevelTree: SalesforceSalesLevels,
  level: number,
  selected: string[]
): string[] {
  let node = salesLevelTree;
  for (let i = 0; i < level - 1; i++) {
    if (!selected[i]) break;
    node = (node as any)[selected[i]] || {};
  }
  return Object.keys(node || {});
}